import React from "react";

function Manager() {
    return <h1>Token Manager</h1>;
}

export default Manager;
